//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import empty from '@/components/empty/index.vue'
    export default {
        components: {
            empty
        },
        data() {
            return {
                valid: true,
                total: 0,
                couponList:[],
                invalid: [],
                orderId: this.$route.query.orderId,//从药房订单结账页过来
                fromType: this.$route.query.fromType,//
                type: this.$route.query.type,
                message: '暂无优惠券'
            }
        },
        //生命周期之挂载完成
        methods: {
            checkPast(){
                this.valid = false;
            },
            //获取优惠券列表
            getMyCoupon(){
                let id = this.$store.state.userInfo.id;
                let list = [];
                let invalid = [];
                this.$doRequest("/api/PlacingOrder/getMypreferentialPrice", { parameters: id }).then(res => {
                    if(res.result == 0){
                        res.parameters.forEach(function (item) {
                            if(item.state == 2 && item.invalidity == 1){
                                list.push(item);
                            }else{
                                invalid.push(item);
                            }
                        });
                        this.couponList = list;
                        this.invalid = invalid;
                        this.total = this.couponList.length;
                    }
                })
            },
            //去使用优惠券
            gotobuy(val,id){
                if(this.$store.state.sun.pd == 1){
                    this.$store.state.sun.pd = 0;
                    if(this.fromType == 'myOrderDetailsYF'){
                        this.$router.push({path: '/myOrderDetailsYF',query: {id: this.orderId,couponId: id,couponSum: val,befrom: this.type,isSelect: true,}});
                    }else{
                        this.$router.push({path: '/buyServiceDetails',query: {id: this.orderId,kfcId: id,kfcSum: val}});
                    }

                }else{
                    return
                }
            },
            //不使用优惠券
            clearcoupon(){
                if(this.$store.state.sun.pd == 1){
                    this.$store.state.sun.pd = 0;
                    this.$store.state.sun.kfc = undefined;
                    if(this.fromType == 'myOrderDetailsYF'){
                        this.$router.push({path: '/myOrderDetailsYF',query: {id: this.orderId,couponId: '',couponSum: '',befrom: this.type,isSelect: true,}});
                    }else{
                        this.$router.push({path: '/buyServiceDetails'});
                    }
                }else{
                    return
                }
            }
        },
        //生命周期之创建完成
        created: function(){
            this.$isLogin(window.location.search.substr(1), this.getMyCoupon);
            document.title = '我的优惠券';
        },
    }



// WEBPACK FOOTER //
// ./src/views/myCoupon/index.vue